import { useCallback } from "react";
import { useQuery } from "react-query";
import { getAttributeDefinitionsByTaskKey, getAttributesGroup } from "components/attributes/lib/attribute-data";
import { formatGroups } from "../format-groups";
import { BRAND_VERIFIED_SHORT_ATTR_LIST } from "components/coding/lib/constants";
import { useFlattenSubGroups } from "shared/hooks/use-flatten-sub-groups";

export const useAllCoderGroups = (codingWipKey, taskKey, codingRoles, references, isSuccess, isBrandVerified) => {
    const flattenSubGroups = useFlattenSubGroups();

    return useQuery({
        queryKey: ["coderGroups", taskKey],
        queryFn: async () => {
            if (isBrandVerified) {
                const groupNames = [BRAND_VERIFIED_SHORT_ATTR_LIST.standard, BRAND_VERIFIED_SHORT_ATTR_LIST.detailed];
                const promises = groupNames.map((groupName) => getAttributesGroup(groupName, codingWipKey));

                return Promise.all(promises).then((attributeGroups) => {
                    const flattenedGroups = flattenSubGroups(attributeGroups);

                    return flattenedGroups;
                });
            }

            return getAttributeDefinitionsByTaskKey(codingWipKey, taskKey, codingRoles.subTaskKeys, references);
        },
        select: useCallback((data) => formatGroups(data), []),
        enabled: isSuccess && !!codingRoles,
    });
};
